import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import { enqueueSnackbar } from "notistack";
import { saveEncryptedDataToSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";



export const login = async (payload) => {
  const url = `${API_BASE_URL}backoffice/LoginBackoffice`;
  try {
    const response = await axios.post(url, payload, {
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  
    const { data } = response;
    if (data.status !== "Error") {
      const { refreshToken, accessToken, email, rol, id } = data.result;
      
      saveEncryptedDataToSessionStorage({...payload, refreshToken, accessToken, email, rol, id}, SECRET_KEY);
      return { refreshToken, accessToken, email, rol };
    } else {
      const errorMessage = data.errors[0];
      enqueueSnackbar(errorMessage, { variant: "error" });
      return { error: errorMessage };
    }
  } catch (error) {
    const errorMsg = error.response
      ? error.response.data
      : "NO SE PUEDE INGRESAR EN ESTE MOMENTO. INTENTELO MÁS TARDE";
    enqueueSnackbar(errorMsg, { variant: "error" });
    return { error: errorMsg };
  }
};

